import React, { useState } from 'react';
import './CourseSection.css';

const CourseSection = () => {
  const [activeGrade, setActiveGrade] = useState('9-12');

  const handleGradeChange = (grade) => {
    setActiveGrade(grade);
  };

  return (
    <section className="course-section">
      <div className="course-heading">
        <h1>
          <span className="purple-text">Choose A Course Or Follow A</span>
          <br />
          <span className="pink-text">Complete Roadmap</span>
        </h1>
      </div>

      <div className="grade-tabs">
        <button 
          className={`grade-tab ${activeGrade === '1-3' ? 'active' : ''}`}
          onClick={() => handleGradeChange('1-3')}
        >
          Grade 1-3
        </button>
        <button 
          className={`grade-tab ${activeGrade === '4-6' ? 'active' : ''}`}
          onClick={() => handleGradeChange('4-6')}
        >
          Grade 4-6
        </button>
        <button 
          className={`grade-tab ${activeGrade === '7-8' ? 'active' : ''}`}
          onClick={() => handleGradeChange('7-8')}
        >
          Grade 7-8
        </button>
        <button 
          className={`grade-tab ${activeGrade === '9-12' ? 'active' : ''}`}
          onClick={() => handleGradeChange('9-12')}
        >
          Grade 9-12
        </button>
      </div>

      <div className="course-cards">
        {/* Polymath Card */}
        <div className={`course-card ${activeGrade !== 'hide' ? '' : 'hidden'}`}>
          <h2 className="card-polymath">Polymath</h2>
          <p>This course is for teenagers to advance coding skills and understand complex concepts.</p>
          
          <div className="learn-section">
            <h3 className="card-polymath">What They'll Learn:</h3>
            <ul className="learn-list">
              <li>C++ Programming</li>
              <li>Web Development Basics in HTML & CSS</li>
              <li>JavaScript Fundamentals</li>
              <li>MySQL Database</li>
              <li>Graphic Designing in Photoshop</li>
              <li>Game Development Basics</li>
            </ul>
          </div>

          <div className="course-details">
            <h3 className="card-polymath">Course Structure:</h3>
            <p>80 Lessons</p>
            <p>80+ Activities | 80 Quizzes</p>
          </div>

          <div className="course-details">
            <h3 className="card-polymath">Duration:</h3>
            <p>10 Months (1 Lesson/Week)</p>
            <p>15 Months (2 Lessons/Week)</p>
          </div>

          <button className="request-btn">Request Curriculum</button>
        </div>

        {/* Polymath+ Card */}
        <div className={`course-card ${activeGrade !== 'hide' ? '' : 'hidden'}`}>
          <h2 className="card-polymathplus">Polymath+</h2>
          <p>A course for young minds to master coding and create websites and tools.</p>
          
          <div className="learn-section">
            <h3 className="card-polymathplus">What They'll Learn:</h3>
            <ul className="learn-list">
              <li>All Polymath Course Modules</li>
              <li>AI Basics</li>
              <li>Advanced Web Development</li>
              <li>PHP Basics</li>
              <li>Advanced Game Development</li>
              <li>Advanced Graphic Designing Tools</li>
            </ul>
          </div>

          <div className="course-details">
            <h3 className="card-polymathplus">Course Structure:</h3>
            <p>135 Lessons</p>
            <p>135+ Activities | 135 Quizzes</p>
          </div>

          <div className="course-details">
            <h3 className="card-polymathplus">Duration:</h3>
            <p>20 Months (1 Lesson/Week)</p>
            <p>15 Months (2 Lessons/Week)</p>
          </div>

          <button className="request-btn">Request Curriculum</button>
        </div>

        {/* Polymath++ Card */}
        <div className={`course-card ${activeGrade !== 'hide' ? '' : 'hidden'}`}>
          <h2 className="card-polymathplusplus">Polymath++</h2>
          <p>The course for teenagers to master coding, design, and UI/UX for a successful future.</p>
          
          <div className="learn-section">
            <h3 className="card-polymathplusplus">What They'll Learn:</h3>
            <ul className="learn-list">
              <li>All Polymath+ Modules</li>
              <li>Advanced AI</li>
              <li>JavaScript Object Model</li>
              <li>(JSON)</li>
              <li>Python Dictionary</li>
              <li>PHP Procedural Programming</li>
              <li>Database Management</li>
              <li>UI/UX Design</li>
            </ul>
          </div>

          <div className="course-details">
            <h3 className="card-polymathplusplus">Course Structure:</h3>
            <p>225 Lessons</p>
            <p>225+ Activities | 225 Quizzes</p>
          </div>

          <div className="course-details">
            <h3 className="card-polymathplusplus">Duration:</h3>
            <p>30 Months (1 Lesson/Week)</p>
            <p>15 Months (2 Lessons/Week)</p>
          </div>

          <button className="request-btn">Request Curriculum</button>
        </div>
      </div>
    </section>
  );
};

export default CourseSection;